"use client";
import { signIn } from "next-auth/react";
import { FaFacebook } from "react-icons/fa";

const FacebookLogin = () => {
  function handleFacebookSignIn() {
    signIn("facebook", { callbackUrl: "/" });
  }
  return (
    <button
      onClick={handleFacebookSignIn}
      type="button"
      className="group flex-1 py-3 border border-border flex items-center justify-center gap-2 px-4 text-sm font-semibold rounded-xl text-foreground bg-white hover:bg-brand-light/40 hover:border-brand-light focus:outline-none focus:ring-2 focus:ring-brand-sky/20 transition-all duration-200 shadow-brand-sm"
    >
      <div className="w-5 h-5 flex items-center justify-center text-[#3b5999] group-hover:scale-110 transition-transform duration-200">
        <FaFacebook size={18} />
      </div>
      Facebook
    </button>
  );
};

export default FacebookLogin;